import { Module, VuexModule, Action } from "vuex-module-decorators";
import api from "@/api/stadium";

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async overview(params: any) {
    return api.overview(params);
  }

  @Action
  async stadiumstatus(params: any) {
    return api.stadiumstatus(params);
  }

  @Action
  async mediastatus(params: any) {
    return api.mediastatus(params);
  }

  @Action
  async sendCommand(params: any) {
    return api.sendCommand(params);
  }

  @Action
  async setControlKeep(params: any) {
    return api.setControlKeep(params);
  }

  @Action
  async setControlOpen(params: any) {
    return api.setControlOpen(params);
  }

  @Action
  async setControlClose(params: any) {
    return api.setControlClose(params);
  }

  @Action
  async getControlPeriod(params: any) {
    return api.getControlPeriod(params);
  }

  @Action
  async setControlPeriod(params: any) {
    return api.setControlPeriod(params);
  }

  @Action
  async updateWithFields(params: any) {
    return api.updateWithFields(params);
  }

  @Action
  async uploadFile(params: any) {
    return api.uploadFile(params);
  }

  @Action
  async getStatistics(params: any) {
    return api.getStatistics(params);
  }

  @Action
  async getOnlineStatusLogs(params: any) {
    return api.getOnlineStatusLogs(params);
  }

  @Action
  async orderOnline(params: any) {
    return api.orderOnline(params);
  }

  @Action
  async orderOffline(params: any) {
    return api.orderOffline(params);
  }

  @Action
  async aiOnline(params: any) {
    return api.aiOnline(params);
  }

  @Action
  async aiOffline(params: any) {
    return api.aiOffline(params);
  }

  @Action
  async phoneOnline(params: any) {
    return api.phoneOnline(params);
  }

  @Action
  async phoneOffline(params: any) {
    return api.phoneOffline(params);
  }

  @Action
  async deliverStadiumEquip(params: any) {
    return api.deliverStadiumEquip(params);
  }

  @Action
  async refreshEquipStatus(params: any) {
    return api.refreshEquipStatus(params);
  }

  @Action
  async getStadium(params: any) {
    return api.getStadium(params);
  }

  @Action
  async getStadiumApplications(params: any) {
    return api.getStadiumApplications(params);
  }

  @Action
  async getStadiums(params: any) {
    return api.getStadiums(params);
  }

  @Action
  async saveStadium2(params: any) {
    return api.saveStadium2(params);
  }

  @Action
  async getStadiumMainEquipments(params: any) {
    return api.getStadiumMainEquipments(params);
  }

  @Action
  async saveStadiumMainEquipment(params: any) {
    return api.saveStadiumMainEquipment(params);
  }

  @Action
  async getStadiumSwitchEquipments(params: any) {
    return api.getStadiumSwitchEquipments(params);
  }

  @Action
  async getStadiumSubEquipments(params: any) {
    return api.getStadiumSubEquipments(params);
  }

  @Action
  async saveStadiumSubEquipment(params: any) {
    return api.saveStadiumSubEquipment(params);
  }

  @Action
  async saveStadiumEquipments(params: any) {
    return api.saveStadiumEquipments(params);
  }

  @Action
  async saveGrounds(params: any) {
    return api.saveGrounds(params);
  }

  @Action
  async getStadiumGrounds(params: any) {
    return api.getStadiumGrounds(params);
  }

  @Action
  async getGround(params: any) {
    return api.getGround(params);
  }

  @Action
  async addGround(params: any) {
    return api.addGround(params);
  }

  @Action
  async editGround(params: any) {
    return api.editGround(params);
  }

  @Action
  async deleteGround(params: any) {
    return api.deleteGround(params);
  }

  @Action
  async checkOrdered(params: any) {
    return api.checkOrdered(params);
  }

  @Action
  async closeList(params: any) {
    return api.closeList(params);
  }

  @Action
  async closeReopen(params: any) {
    return api.closeReopen(params);
  }

  @Action
  async orderedGround(params: any) {
    return api.orderedGround(params);
  }

  @Action
  async orderedGroundDelete(params: any) {
    return api.orderedGroundDelete(params);
  }

  @Action
  async orderedGroundDeleteById(params: any) {
    return api.orderedGroundDeleteById(params);
  }

  @Action
  async groundEvents(params: any) {
    return api.groundEvents(params);
  }

  @Action
  async groundEventsCount(params: any) {
    return api.groundEventsCount(params);
  }

  @Action
  async getStadiumGroundTimeCost(params: any) {
    return api.getStadiumGroundTimeCost(params);
  }

  @Action
  async editStadiumGroundTimeCost(params: any) {
    return api.editStadiumGroundTimeCost(params);
  }

  @Action
  async deleteStadiumGroundTimeCost(params: any) {
    return api.deleteStadiumGroundTimeCost(params);
  }

  @Action
  async getStadiumPriceSetting(params: any) {
    return api.getStadiumPriceSetting(params);
  }

  @Action
  async saveStadiumPriceSetting(params: any) {
    return api.saveStadiumPriceSetting(params);
  }

  @Action
  async addStadiumPrice(params: any) {
    return api.addStadiumPrice(params);
  }

  @Action
  async editStadiumPrice(params: any) {
    return api.editStadiumPrice(params);
  }

  @Action
  async resetStadiumPrice(params: any) {
    return api.resetStadiumPrice(params);
  }

  @Action
  async businessTime(params: any) {
    return api.businessTime(params);
  }

  @Action
  async getTags(params: any) {
    return api.getTags(params);
  }

  @Action
  async getStadiumTags(params: any) {
    return api.getStadiumTags(params);
  }

  @Action
  async saveStadiumTags(params: any) {
    return api.saveStadiumTags(params);
  }

  @Action
  async saveStadiumDetail(params: any) {
    return api.saveStadiumDetail(params);
  }

  @Action
  async aiOnlineNotice(params: any) {
    return api.aiOnlineNotice(params);
  }

  @Action
  async orderOnlineNotice(params: any) {
    return api.orderOnlineNotice(params);
  }

  @Action
  async updateAiSignTime(params: any) {
    return api.updateAiOnLineTime(params);
  }

  @Action
  async updateAiOnLineTime(params: any) {
    return api.updateAiOnLineTime(params);
  }

  @Action
  async getEquipCameras(params: any) {
    return api.getEquipCameras(params);
  }

  @Action
  async addEquipCamera(params: any) {
    return api.addEquipCamera(params);
  }

  @Action
  async editEquipCamera(params: any) {
    return api.editEquipCamera(params);
  }

  @Action
  async getEquipCamera(params: any) {
    return api.getEquipCamera(params);
  }

  @Action
  async deleteEquipCamera(params: any) {
    return api.deleteEquipCamera(params);
  }

  @Action
  async getQrcode(params: any) {
    return api.getQrcode(params);
  }

  @Action
  async addBalance(params: any) {
    return api.addBalance(params);
  }

  @Action
  async getBalances(params: any) {
    return api.getBalances(params);
  }

  @Action
  async rechargeBalance(params: any) {
    return api.rechargeBalance(params);
  }

  @Action
  async deductBalance(params: any) {
    return api.deductBalance(params);
  }

  @Action
  async applyInfo(params: any) {
    return api.applyInfo(params);
  }

  @Action
  async applyInfo1(params: any) {
    return api.applyInfo1(params);
  }

  @Action
  async bookingInfo(params: any) {
    return api.bookingInfo(params);
  }

  @Action
  async applyUpdate(params: any) {
    return api.applyUpdate(params);
  }

  @Action
  async applyComplete(params: any) {
    return api.applyComplete(params);
  }

  @Action
  async applyHandle(params: any) {
    return api.applyHandle(params);
  }

  @Action
  async applyRecord(params: any) {
    return api.applyRecord(params);
  }

  @Action
  async applyUserAction(params: any) {
    return api.applyUserAction(params);
  }

  @Action
  async applyAuditHistory(params: any) {
    return api.applyAuditHistory(params);
  }

  @Action
  async add(params: any) {
    return api.add(params);
  }

  @Action
  async restartSubEquip(params: any) {
    return api.restartSubEquip(params);
  }

  @Action
  async toggleSubEquip(params: any) {
    return api.toggleSubEquip(params);
  }

  @Action
  async toggleMainEquip(params: any) {
    return api.toggleMainEquip(params);
  }

  @Action
  async toggleVideoEquip(params: any) {
    return api.toggleVideoEquip(params);
  }

  @Action
  async settlementItems(params: any) {
    return api.settlementItems(params);
  }

  @Action
  async settlementAddItem(params: any) {
    return api.settlementAddItem(params);
  }

  @Action
  async settlementEditItem(params: any) {
    return api.settlementEditItem(params);
  }

  @Action
  async settlementItem(params: any) {
    return api.settlementItem(params);
  }

  @Action
  async settlementSetting(params: any) {
    return api.settlementSetting(params);
  }

  @Action
  async settlementSettingSave(params: any) {
    return api.settlementSettingSave(params);
  }

  @Action
  async settlementSettingSaveDate(params: any) {
    return api.settlementSettingSaveDate(params);
  }

  @Action
  async settlementSettingSaveName(params: any) {
    return api.settlementSettingSaveName(params);
  }

  @Action
  async settlementItemsDetailList(params: any) {
    return api.settlementItemsDetailList(params);
  }

  @Action
  async settlementItemsDetailAdd(params: any) {
    return api.settlementItemsDetailAdd(params);
  }

  @Action
  async settlementItemsDetailEdit(params: any) {
    return api.settlementItemsDetailEdit(params);
  }

  @Action
  async settlementItemsDetailDetail(params: any) {
    return api.settlementItemsDetailDetail(params);
  }

  @Action
  async settlementItemsDetailDelete(params: any) {
    return api.settlementItemsDetailDelete(params);
  }

  @Action
  async onlineProgress(params: any) {
    return api.onlineProgress(params);
  }

  @Action
  async allowNotUpgrade(params: any) {
    return api.allowNotUpgrade(params);
  }

  @Action
  async allowUpgrade(params: any) {
    return api.allowUpgrade(params);
  }

  @Action
  async allowUpgradeStatus(params: any) {
    return api.allowUpgradeStatus(params);
  }

  @Action
  async regenerate(params: any) {
    return api.regenerate(params);
  }

  @Action
  async manageRecordList(params: any) {
    return api.manageRecordList(params);
  }

  @Action
  async manageRecordDetail(params: any) {
    return api.manageRecordDetail(params);
  }

  @Action
  async claims(params: any) {
    return api.claims(params);
  }

  @Action
  async sendinvitecode(params: any) {
    return api.sendinvitecode(params);
  }

  @Action
  async reportrollscreen(params: any) {
    return api.rollscreenimage(params);
  }

  @Action
  async reportpathai(params: any) {
    return api.reportpathai(params);
  }

  @Action
  async reportpathonline(params: any) {
    return api.reportpathonline(params);
  }

  @Action
  async reportdownqrcode(params: any) {
    return api.reportdownqrcode(params);
  }

  @Action
  async reportprintqrcode(params: any) {
    return api.reportprintqrcode(params);
  }

  @Action
  async downqrcode(params: any) {
    return api.downqrcode(params);
  }

  @Action
  async miniprogramqrcode(params: any) {
    return api.miniprogramqrcode(params);
  }

  @Action
  async getGroundRobots(params: any) {
    return api.getGroundRobots(params);
  }

  @Action
  async changeGroundRobotStatus(params: any) {
    return api.changeGroundRobotStatus(params);
  }

  @Action
  async settingDetail(params: any) {
    return api.settingDetail(params);
  }

  @Action
  async settingChange(params: any) {
    return api.settingChange(params);
  }

  @Action
  async unbindweixin(params: any) {
    return api.unbindweixin(params);
  }

  @Action
  async discovery(params: any) {
    return api.discovery(params);
  }

  @Action
  async discoverydetail(params: any) {
    return api.discoverydetail(params);
  }

  @Action
  async discoveryhandle(params: any) {
    return api.discoveryhandle(params);
  }

  @Action
  async vips(params: any) {
    return api.vips(params);
  }

  @Action
  async addvip(params: any) {
    return api.addvip(params);
  }

  @Action
  async getvipsetting(params: any) {
    return api.getvipsetting(params);
  }

  @Action
  async savevipsetting(params: any) {
    return api.savevipsetting(params);
  }

  @Action
  async changeVipSettingStatus(params: any) {
    return api.changeVipSettingStatus(params);
  }

  @Action
  async vipSettingAdd(params: any) {
    return api.vipSettingAdd(params);
  }

  @Action
  async vipSettingEdit(params: any) {
    return api.vipSettingEdit(params);
  }

  @Action
  async vipSettingDelete(params: any) {
    return api.vipSettingDelete(params);
  }

  @Action
  async vipSettingOn(params: any) {
    return api.vipSettingOn(params);
  }

  @Action
  async vipSettingOff(params: any) {
    return api.vipSettingOff(params);
  }

  @Action
  async users(params: any) {
    return api.users(params);
  }

  @Action
  async deleteUser(params: any) {
    return api.deleteUser(params);
  }

  @Action
  async accounts(params: any) {
    return api.accounts(params);
  }

  @Action
  async addAccount(params: any) {
    return api.addAccount(params);
  }

  @Action
  async editAccount(params: any) {
    return api.editAccount(params);
  }

  @Action
  async getAccount(params: any) {
    return api.getAccount(params);
  }

  @Action
  async deleteAccount(params: any) {
    return api.deleteAccount(params);
  }

  @Action
  async changeAccountStatus(params: any) {
    return api.changeAccountStatus(params);
  }

  @Action
  async permissions(params: any) {
    return api.permissions(params);
  }

  @Action
  async roles(params: any) {
    return api.roles(params);
  }

  @Action
  async similar(params: any) {
    return api.similar(params);
  }

  @Action
  async notes(params: any) {
    return api.notes(params);
  }

  @Action
  async addnote(params: any) {
    return api.addnote(params);
  }

  @Action
  async addStadium(params: any) {
    return api.addStadium(params);
  }

  @Action
  async addCertificate(params: any) {
    return api.addCertificate(params);
  }

  @Action
  async addAgreement(params: any) {
    return api.addAgreement(params);
  }

  @Action
  async getClosuretime(params: any) {
    return api.getClosuretime(params);
  }

  @Action
  async saveClosuretime(params: any) {
    return api.saveClosuretime(params);
  }

  @Action
  async getMedia(params: any) {
    return api.getMedia(params);
  }

  @Action
  async saveMedia(params: any) {
    return api.saveMedia(params);
  }

  @Action
  async getBank(params: any) {
    return api.getBank(params);
  }

  @Action
  async saveBank(params: any) {
    return api.saveBank(params);
  }

  @Action
  async getReport(params: any) {
    return api.getReport(params);
  }

  @Action
  async saveReport(params: any) {
    return api.saveReport(params);
  }

  @Action
  async saveSaler(params: any) {
    return api.saveSaler(params);
  }

  @Action
  async getExpense(params: any) {
    return api.getExpense(params);
  }

  @Action
  async saveExpense(params: any) {
    return api.saveExpense(params);
  }

  @Action
  async getBlocks(params: any) {
    return api.getBlocks(params);
  }

  @Action
  async addBlock(params: any) {
    return api.addBlock(params);
  }

  @Action
  async editBlock(params: any) {
    return api.editBlock(params);
  }

  @Action
  async getBlock(params: any) {
    return api.getBlock(params);
  }

  @Action
  async deleteBlock(params: any) {
    return api.deleteBlock(params);
  }

  @Action
  async authuserlist(params: any) {
    return api.authuserlist(params);
  }

  @Action
  async addauthuser(params: any) {
    return api.addauthuser(params);
  }

  @Action
  async editauthuser(params: any) {
    return api.editauthuser(params);
  }

  @Action
  async getauthuser(params: any) {
    return api.getauthuser(params);
  }

  @Action
  async deleteauthuser(params: any) {
    return api.deleteauthuser(params);
  }

  @Action
  async customaudioplay(params: any) {
    return api.customaudioplay(params);
  }

  @Action
  async addcustomaudioplay(params: any) {
    return api.addcustomaudioplay(params);
  }

  @Action
  async againcustomaudioplay(params: any) {
    return api.againcustomaudioplay(params);
  }

  @Action
  async addrank(params: any) {
    return api.addrank(params);
  }

  @Action
  async waitSettlement(params: any) {
    return api.waitSettlement(params);
  }

  @Action
  async copyDemoData(params: any) {
    return api.copyDemoData(params);
  }

  @Action
  async deleteDemoData(params: any) {
    return api.deleteDemoData(params);
  }

  @Action
  async manager(params: any) {
    return api.manager(params);
  }

  @Action
  async managerlogout(params: any) {
    return api.managerlogout(params);
  }

  @Action
  async products(params: any) {
    return api.products(params);
  }

  @Action
  async addproduct(params: any) {
    return api.addproduct(params);
  }

  @Action
  async editproduct(params: any) {
    return api.editproduct(params);
  }

  @Action
  async getproduct(params: any) {
    return api.getproduct(params);
  }

  @Action
  async deleteproduct(params: any) {
    return api.deleteproduct(params);
  }

  @Action
  async priceextend(params: any) {
    return api.priceextend(params);
  }

  @Action
  async addpriceextend(params: any) {
    return api.addpriceextend(params);
  }

  @Action
  async editpriceextend(params: any) {
    return api.editpriceextend(params);
  }

  @Action
  async getpriceextend(params: any) {
    return api.getpriceextend(params);
  }

  @Action
  async deletepriceextend(params: any) {
    return api.deletepriceextend(params);
  }

  @Action
  async timeSaleSetting(params: any) {
    return api.timeSaleSetting(params);
  }

  @Action
  async timeSaleSettingAdd(params: any) {
    return api.timeSaleSettingAdd(params);
  }

  @Action
  async timeSaleSettingEdit(params: any) {
    return api.timeSaleSettingEdit(params);
  }

  @Action
  async timeSaleSettingDetail(params: any) {
    return api.timeSaleSettingDetail(params);
  }

  @Action
  async timeSaleSettingDelete(params: any) {
    return api.timeSaleSettingDelete(params);
  }

  @Action
  async bindAuthUser(params: any) {
    return api.bindAuthUser(params);
  }

  @Action
  async unbindAuthUser(params: any) {
    return api.unbindAuthUser(params);
  }

  @Action
  async getParamsSetting(params: any) {
    return api.getParamsSetting(params);
  }

  @Action
  async postParamsSetting(params: any) {
    return api.postParamsSetting(params);
  }

  @Action
  async setIsInternal(params: any) {
    return api.setIsInternal(params);
  }

  @Action
  async resignApplyAgreement(params: any) {
    return api.resignApplyAgreement(params);
  }

  @Action
  async resignAIAgreement(params: any) {
    return api.resignAIAgreement(params);
  }

  @Action
  async activeOnlineReadTime(params: any) {
    return api.activeOnlineReadTime(params);
  }

  @Action
  async wechatStadiumSetting(params: any) {
    return api.wechatStadiumSetting(params);
  }

  @Action
  async internalStadiumSetting(params: any) {
    return api.internalStadiumSetting(params);
  }

  @Action
  async changeVersion(params: any) {
    return api.changeVersion(params);
  }

  @Action
  async reduceToPhoneOnline(params: any) {
    return api.reduceToPhoneOnline(params);
  }

  @Action
  async todayBuy(params: any) {
    return api.todayBuy(params);
  }

  @Action
  async todayPlay(params: any) {
    return api.todayPlay(params);
  }

  @Action
  async dailySituationInfo(params: any) {
    return api.dailySituationInfo(params);
  }

  @Action
  async researchReport(params: any) {
    return api.researchReport(params);
  }

  @Action
  async researchReportSave(params: any) {
    return api.researchReportSave(params);
  }

  @Action
  async researchReportDetail(params: any) {
    return api.researchReportDetail(params);
  }

  @Action
  async researchReportChangeField(params: any) {
    return api.researchReportChangeField(params);
  }

  @Action
  async nearStadium(params: any) {
    return api.nearStadium(params);
  }

  @Action
  async userPlayer(params: any) {
    return api.userPlayer(params);
  }

  @Action
  async getTaisamSetting(params: any) {
    return api.getTaisamSetting(params);
  }

  @Action
  async saveTaisamSetting(params: any) {
    return api.saveTaisamSetting(params);
  }

  @Action
  async taisamAnaly(params: any) {
    return api.taisamAnaly(params);
  }

  @Action
  async countBill(params: any) {
    return api.countBill(params);
  }

  @Action
  async initStadiumEquipment(params: any) {
    return api.initStadiumEquipment(params);
  }
  @Action
  async costAB(params: any) {
    return api.costAB(params);
  }

  @Action
  async billAB(params: any) {
    return api.billAB(params);
  }

  @Action
  async cloneStadium(params:any){
    return api.cloneStadium(params);
  }
}
